var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 78.351 70.994",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "5px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.86 35.508a33 33 0 1 1 13.13 26.34",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(-7.14 -14.492)",
    points: "25.25 48.13 17.38 56 9.64 48.27",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(-7.14 -14.492)",
    points: "49.11 34.83 49.11 51.44 60.13 61.43",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayback);
export default __webpack_public_path__ + "static/media/playback.af9b1b75.svg";
export { ForwardRef as ReactComponent };